module.exports = __webpack_public_path__ + "img/Elven_Shield_01.e49126fa.png";